import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { IntlWrapper } from './intl';
import { createStore } from './store';
import './style.css';
// import App from './App';
import { getInterfaceLanguage } from './utils/getInterfaceLanguage';
import { createTheme, ThemeContext } from '@hmsexp/component-library';
import Routes from './web/routes';
import Analytics from '../../common/utils/analyticsUtil';
import Popover from '../../common/components/Popover';
import firebaseUtils from '../../common/firebaseUtils';
const language = getInterfaceLanguage();
const analyticsTarget = process.env.CLIENT === 'CHINA' ? 'Umeng' : 'GA';

Analytics.initializeAnalyticsTarget({
  analyticsTarget:analyticsTarget,
  trackingIdUA:process.env.REACT_APP_GA_TRACKING_ID,
  trackingIdGA4:process.env.REACT_APP_GA4_TRACKING_ID
});
try {
  firebaseUtils.configureFirebasePerformance();
} catch (e) {
  console.error('error of firebase performance analyser', e);
}
const selfOnboarding = (containerId, props) => {

  const store = createStore({});
  const theme = createTheme({ theme: 'light' });
  ReactDOM.render(
    <Provider store={store}>
      <IntlWrapper locale={props.sharedState.language || language}>
        <ThemeContext.Provider value={theme}>
          <Routes />
          <Popover />
        </ThemeContext.Provider>
      </IntlWrapper>
    </Provider>,document.getElementById(containerId))
};

// window.renderSelfOnboarding = selfOnboarding;
// window.unmountSelfOnboarding = containerId => {
//   ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
// };

Sentry.init({ dsn: process.env.REACT_APP_SENTRY_CLIENT_DSN });

if (!document.getElementById('OyoOSSupport-container')) {
  selfOnboarding('root', {
    sharedState: {}
  });
}
